// eslint-disable-next-line import/no-extraneous-dependencies
import { tns, TinySliderSettings, TinySliderInstance, TinySliderInfo } from 'tiny-slider/src/tiny-slider';
import classify from '../../helpers/classify';

export function initCarousel(carouselContainer: HTMLDivElement, CAROUSEL: string): TinySliderInstance | null {
  const CAROUSEL_CONTAINER = `${CAROUSEL}__container`;
  const CONTROLS_CONTAINER = `${CAROUSEL}__controls-container`;
  const NAVIGATION_CONTAINER = 'tns-nav';
  const NAVIGATION_LINE = `${CAROUSEL}__nav-line`;
  const GUTTER = 32;
  const carousel = carouselContainer.querySelector<HTMLDivElement>(classify(CAROUSEL));
  const controlsContainer = carouselContainer.querySelector<HTMLDivElement>(classify(CONTROLS_CONTAINER)) || undefined;

  if (!carousel) {
    return null;
  }

  const tileSizes: { smallTiles: number; largeTiles: number } = {
    smallTiles: 220,
    largeTiles: 342
  };

  const sliderOptions: TinySliderSettings = {
    container: carousel,
    items: 1,
    controlsContainer,
    loop: false,
    nav: false,
    navPosition: 'bottom',
    preventActionWhenRunning: true,
    gutter: GUTTER,
    fixedWidth: tileSizes.smallTiles,
    responsive: {
      768: {
        nav: true,
        mouseDrag: true,
        fixedWidth: carouselContainer.classList.contains(`${CAROUSEL_CONTAINER}--large-tiles`)
          ? tileSizes.largeTiles
          : tileSizes.smallTiles
      }
    }
  };

  function initNavigation(slider: TinySliderInstance): void {
    const carouselNavContainer = carouselContainer.querySelector<HTMLDivElement>(classify(NAVIGATION_CONTAINER));

    (function createNavLineElement(): void {
      const navLine = document.createElement('hr');
      navLine.classList.add(NAVIGATION_LINE);
      carouselNavContainer?.firstElementChild?.appendChild(navLine);
    })();

    function updateNavigation(): void {
      const navLine = carouselContainer.querySelector<HTMLHRElement>(classify(NAVIGATION_LINE));
      const info = slider.getInfo() as TinySliderInfo & { pages: number };

      if (!info.pages || !navLine) {
        return;
      }

      const currentPage = info.navCurrentIndex || 0;
      navLine.style.transform = `translateX(${100 * currentPage}%)`;
    }

    slider.events.on('indexChanged', updateNavigation);
  }

  carouselContainer.classList.remove('hide-visibility');
  const slider = tns(sliderOptions);
  initNavigation(slider);

  return slider;
}

export function initAllCarousels(carousel: string): void {
  const CAROUSEL_CONTAINER = `${carousel}__container`;

  const findAllCarouselContainers = (): NodeListOf<HTMLDivElement> =>
    document.querySelectorAll<HTMLDivElement>(classify(CAROUSEL_CONTAINER));

  const allCarouselContainers = findAllCarouselContainers();
  allCarouselContainers.forEach((carouselContainer) => initCarousel(carouselContainer, carousel));
}
